
import React from 'react';

const AdRequestLoadingState: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="text-center">
        <div className="w-8 h-8 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">Chargement de vos informations...</p>
      </div>
    </div>
  );
};

export default AdRequestLoadingState;
